import { useCallback, useEffect } from 'react';

import { useMediaQuery } from '@hrworks/design-system/hooks';

import { Branding } from '../Branding/Branding';
import { SidebarToggle } from '../SidebarToggle/SidebarToggle';
import { useSqwLayout } from '../SqwLayoutContext';
import { S } from './Sidebars.styles';
import type { SidebarsProps } from './Sidebars.types';

export const Sidebars = ({ header, sidebar, ...otherProps }: SidebarsProps) => {
  const { isMobileSidebarExpanded, setIsMobileSidebarExpanded, isSidebarCollapsed } = useSqwLayout();
  const isSmallDevice = useMediaQuery('isSmallDevice');

  const onKeyDown = useCallback(
    ({ key }: KeyboardEvent) => {
      isSmallDevice && isMobileSidebarExpanded && key === 'Escape' && setIsMobileSidebarExpanded(false);
    },
    [isSmallDevice, isMobileSidebarExpanded, setIsMobileSidebarExpanded],
  );

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);

  return (
    <>
      <S.DesktopSidebar $isSidebarCollapsed={isSidebarCollapsed} {...sidebar} {...otherProps} />
      <S.MobileSidebar
        isExpanded={isMobileSidebarExpanded}
        brandingElement={
          <Branding logo={header?.logo}>
            <SidebarToggle variant="subtle" />
          </Branding>
        }
        showUpperSidebarChildren
        {...sidebar}
      />
    </>
  );
};
